import { FC } from "react";
import { Route, RouteComponentProps, Switch } from "react-router-dom";
import { routeHelpersStatements } from "./paths";
import { RouteStatements } from "./routes/RouteStatements";

export const StatementIndex: FC<RouteComponentProps> = () => {
  return (
    <Switch>
      <Route path={routeHelpersStatements.path} component={RouteStatements} />
    </Switch>
  );
};
